export const FF_COPY_TO_AI_ASSISTANT = 'ff-f2w-copy-to-ai-assistant';
